import { LessonProblem, StudentProblemResult } from '@yandex-int/k-common/typings';
import { Text } from 'platform-components';
import React, { useMemo } from 'react';

import { PROBLEM_DISPLAY_STATUS } from 'common.components/student-lesson-stat/typings';
import { getProblemDisplayStatus } from 'common.components/student-lesson-stat/utils';

import { StatItem } from '../lesson-content__stat-item-wrapper';

const stub = <>&mdash;</>;

export const StudentPoints = (props: {
    isLessonScoreAvailable: boolean;
    studentProblemResult: StudentProblemResult | null;
    problemLink: LessonProblem;
}) => {
    const { studentProblemResult, problemLink, isLessonScoreAvailable } = props;

    const status = getProblemDisplayStatus(problemLink, studentProblemResult);

    const value = useMemo(() => {
        if (status === PROBLEM_DISPLAY_STATUS.NOT_SOLVED || !isLessonScoreAvailable) {
            return stub;
        }

        return studentProblemResult?.points || stub;
    }, [isLessonScoreAvailable, status, studentProblemResult]);

    return (
        <StatItem>
            <Text id="studentLessonStat.pointsForProblem" />
            <span className="lesson-content__stat-detail-value qa_stat-detail-points">
                <Text weight={Text.WEIGHT.L}>{value}</Text>
            </span>
        </StatItem>
    );
};
